import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "gfu-layout__main js-main-content",
  "data-qa": "creator-projects"
}
const _hoisted_2 = { class: "gfu-hd gfu-hd--h1 _mt-6 _mb-3" }
const _hoisted_3 = { "format-key": "0" }
const _hoisted_4 = { class: "gfu-card-list gfu-card-list--wrap" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_project_recommendations = _resolveComponent("project-recommendations")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createVNode(_component_localize, {
        resource: _ctx.Resources.Layout.CreatorProjectsHeader
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, _toDisplayString($options.creatorProjectsPluralized), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["resource"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.projectItems, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.props.projectID,
          class: "gfu-card-list__item gfu-1of1 gfu-1of3--m gfu-1of4--l"
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), _mergeProps({ ref_for: true }, item.props), null, 16 /* FULL_PROPS */))
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    (_ctx.isInitialized)
      ? (_openBlock(), _createBlock(_component_project_recommendations, {
          key: 0,
          class: "_mt-6",
          quantity: 8,
          "extra-large-screen-visible-items-count": 4,
          "large-screen-visible-items-count": 4,
          "medium-screen-visible-items-count": 3,
          source: "creator-page",
          "exclude-project-ids": $options.projectIDs,
          "data-qa": "Recommendations"
        }, null, 8 /* PROPS */, ["exclude-project-ids"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_progress_overlay, {
      visible: _ctx.isProcessing,
      sticky: true
    }, null, 8 /* PROPS */, ["visible"])
  ]))
}